import { render, staticRenderFns } from "./ChatSkeleton.vue?vue&type=template&id=9ce1a35e&scoped=true"
import script from "./ChatSkeleton.vue?vue&type=script&lang=js"
export * from "./ChatSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ChatSkeleton.vue?vue&type=style&index=0&id=9ce1a35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce1a35e",
  null
  
)

export default component.exports